import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function OldSolutionsSection() {
  const failures = [{
    tried: '“A ver si se da”',
    why: 'La rutina nunca produce el momento perfecto.'
  }, {
    tried: 'Hacer un intento grande',
    why: 'Mucho riesgo emocional: si sale mal, duele el doble.'
  }, {
    tried: 'Hablarlo serio en el momento',
    why: 'Se siente como reclamo/terapia, mata el deseo.'
  }, {
    tried: 'Copiar ideas “hot” de internet',
    why: 'No encajan con su personalidad; se siente actuado.'
  }];
  return <section className="py-20 bg-white px-6" data-id="element-300">
      <div className="container mx-auto max-w-5xl" data-id="element-301">
        <div className="text-center mb-16" data-id="element-302">
          <h2 className="text-3xl md:text-4xl font-bold text-wine-dark mb-4" data-id="element-303">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-lg text-charcoal/60" data-id="element-304">
            No es tu culpa. Es que las soluciones tradicionales ignoran el miedo
            al rechazo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-305">
          {failures.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-cream p-6 rounded-xl border border-cream-dark hover:border-wine/20 transition-colors" data-id="element-306">
              <div className="flex items-start gap-4" data-id="element-307">
                <XCircle className="w-6 h-6 text-wine/60 flex-shrink-0 mt-1" data-id="element-308" />
                <div data-id="element-309">
                  <h3 className="font-serif font-bold text-xl text-wine-dark mb-2" data-id="element-310">
                    {item.tried}
                  </h3>
                  <p className="text-charcoal/80" data-id="element-311">{item.why}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}